import { render, staticRenderFns } from "./UserLabel.vue?vue&type=template&id=bb2b43a4"
import script from "./UserLabel.vue?vue&type=script&lang=js"
export * from "./UserLabel.vue?vue&type=script&lang=js"
import style0 from "./UserLabel.vue?vue&type=style&index=0&id=bb2b43a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports